import { gql } from '@apollo/client';

/**
 * Заказ выгрузки данных для P&L (ТЗ 0075). Файл собирается в фоне: мутация
 * возвращает заказ в статусе `pending`, дальше экран опрашивает `PnlExportRuns`.
 *
 * Операция называется `OrderPnlExport`, а не `RequestPnlExport`: тип ответа на
 * бэкенде — класс `RequestPnlExportMutation`, и кодоген выдал бы два
 * `export type RequestPnlExportMutation` (тип схемы и тип операции) —
 * «Duplicate identifier». Поля перечислены без фрагмента (кодоген пропускает `gql`
 * с интерполяцией).
 */
export const OrderPnlExportMutationDocument = gql`
  mutation OrderPnlExport(
    $monthFrom: String!
    $monthTo: String!
    $fileFormat: String!
    $language: String
    $groupId: ID
  ) {
    requestPnlExport(
      monthFrom: $monthFrom
      monthTo: $monthTo
      fileFormat: $fileFormat
      language: $language
      groupId: $groupId
    ) {
      success
      customErrors {
        field
        code
        message
      }
      run {
        id
        status
        fileFormat
        language
        monthFrom
        monthTo
        groupId
        groupName
        fileName
        size
        stats
        error
        createdByName
        createdAt
        finishedAt
        isDownloadable
        isFilePurged
      }
    }
  }
`;
